import { useContext } from 'react';
import { Context } from '../../../Context';
import { useTranslation } from 'react-i18next';
import ToggleButtonsGroup from '../../../components/_shared/ToggleButtonsGroup';
import styles from '../../../styles/aprt.module.scss';
import buttons_styles from '../../../styles/buttons.module.scss';

function BuildingTierList() {
	const { t } = useTranslation();
	const {
		activeApartmentSelectedTier,
		setActiveApartmentSelectedTier,
		activeApartmentData,
		tiersData,
	} = useContext(Context);

	const apartmentRefTiers =
		activeApartmentData.tiers.map((tier) => tier.ref_tier) || [];

	const labelStyles = {
		display: 'block',
		fontSize: '0.8rem',
		color: '#666',
	};
	//TODO: move to utility functions
	const capitalizeFirstWord = (str) => {
		if (!str) return '';
		const words = str.toLowerCase().split(' ');
		if (words.length > 0) {
			words[0] = words[0].charAt(0).toUpperCase() + words[0].slice(1);
		}
		return words.join(' ');
	};



	if (!apartmentRefTiers || apartmentRefTiers.length <= 1) {
		return null; // No tiers to display
	}
	return (
		<div className={styles.tierList__container}>
			<ToggleButtonsGroup vertical={true} >
				{apartmentRefTiers.map((tier, index) => (
					<button
						key={index}
						className={`${buttons_styles['bim_button']} ${
							tier === activeApartmentSelectedTier
								? `${buttons_styles['bim_button--selected']}`
								: ''
						}`}
						onClick={() => setActiveApartmentSelectedTier(tier)}
					>
						{tier}
					</button>
				)).reverse()}
			</ToggleButtonsGroup>
			<span style={labelStyles}>Poziomy:</span>
		</div>
	);
}

export default BuildingTierList;
